import { Button, IconName } from '@optimus-web/core';
import { LocalizedText, useDialog, useFeatureFlag } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { WithGuideLink } from '@mews-commander/types';
import {
    EnterpriseLinkButton,
    LocalizedPageTitle,
    PortfolioLayoutHeader,
    TooltippedIconButton,
} from '@mews-commander/ui';
import { CreateRoleDialog } from '../CreateRole';
import { usePortfolioSelectors } from '../utils';
import { useExportRoles } from './queries';

export const PortfolioRolesListHeader: React.FC<WithGuideLink> = ({ guideLink }) => {
    const exportRoles = useExportRoles();
    const { isPortfolio, hasMultiPropertyAccess } = usePortfolioSelectors();
    const [createRoleDialogProps, toggleCreateRoleDialog] = useDialog();

    const newPermissionsEnabled = useFeatureFlag(FeatureFlag.newPermissionsEnabled);

    return (
        <>
            <PortfolioLayoutHeader
                title={<LocalizedPageTitle textKey={isPortfolio ? TextKey.CentralizedRoles : TextKey.Roles} />}
                guideLink={guideLink}
                rightSide={
                    <>
                        {newPermissionsEnabled ? (
                            <EnterpriseLinkButton
                                icon={IconName.Add}
                                size="medium"
                                variant="tertiary"
                                to="Roles/CreateRole"
                            >
                                <LocalizedText textKey={TextKey.CreateRole} />
                            </EnterpriseLinkButton>
                        ) : (
                            <Button
                                icon={IconName.Add}
                                onClick={toggleCreateRoleDialog}
                                size="medium"
                                variant="tertiary"
                                type="submit"
                            >
                                <LocalizedText textKey={TextKey.CreateRole} />
                            </Button>
                        )}
                        {hasMultiPropertyAccess ? (
                            <TooltippedIconButton
                                tooltip={<LocalizedText textKey={TextKey.ExportToExcel} />}
                                onClick={() => exportRoles.mutate()}
                                size="medium"
                                variant="tertiary"
                                icon={IconName.Exports}
                                loading={exportRoles.isPending}
                                type="button"
                            />
                        ) : null}
                    </>
                }
            />
            <CreateRoleDialog {...createRoleDialogProps} />
        </>
    );
};
